import styled from 'styled-components';

interface ContainerProps {
  isOrganization?: boolean;
  flexCol?: boolean;
}

const Container = styled.div<ContainerProps>`
  width: calc(100% - 32px);
  margin: 0 auto;
  display: flex;
  ${({ flexCol = false }) => flexCol && `flex-direction: column;`}
  padding-bottom: ${props => (props.isOrganization ? 55 : 0)};

  @media (min-width: 768px) {
    margin: 0px auto 0px;
    width: calc(100% - 64px);
  }

  @media (min-width: 1280px) {
    width: 1140px;
  }

  @media (min-width: 1440px) {
    width: 1280px;
  }

  @media (min-width: 1680px) {
    width: 1560px;
  }
`;

export default Container;
